import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const InfoFullIcon = (props: IconProps) => (
  <IconBox {...props}>
    <path
      d="M54.6289 9.3721C42.1321 -3.12334 21.8703 -3.12473 9.3721 9.3721C-3.12473 21.8689 -3.12334 42.1307 9.3721 54.6289C21.8689 67.123 42.1307 67.1244 54.6289 54.6289C67.1244 42.1307 67.123 21.8703 54.6289 9.3721ZM36.1731 45.9137C36.1731 48.2191 34.3046 50.0877 31.9991 50.0877C29.6937 50.0877 27.8252 48.2191 27.8252 45.9137V29.2179C27.8252 26.9125 29.6937 25.0439 31.9991 25.0439C34.3046 25.0439 36.1731 26.9125 36.1731 29.2179V45.9137ZM31.9254 22.0832C29.5212 22.0832 27.9184 20.3802 27.9685 18.2779C27.9184 16.0741 29.5212 14.4226 31.9741 14.4226C34.4284 14.4226 35.9811 16.0755 36.0326 18.2779C36.0312 20.3802 34.4298 22.0832 31.9254 22.0832Z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
  </IconBox>
);

export default InfoFullIcon;
